class Tabs {
    constructor() {
        this.tabs = document.querySelectorAll('.js-tabs');
        this.tabs.forEach((tabs) => {
            Tabs.hideAllBlocks(tabs);
            Tabs.bindTabClick(tabs);
            let firstTab = null;
            if (sessionStorage.getItem('currentTab')) {
                firstTab = tabs.querySelector(`.js-tab[data-tab="${sessionStorage.getItem('currentTab')}"]`);
            }
            if (!firstTab && this.tabs.length === 1) {
                firstTab = tabs.querySelector('.js-tab');
            }
            if (firstTab) {
                Tabs.showContentTab(firstTab);
            }
        });
    }

    static hideAllBlocks(tabs) {
        tabs.querySelectorAll('.js-tab').forEach((item) => {
            item.classList.remove('active');
        });
        tabs.querySelectorAll('.js-tabs-blocks').forEach((blocks) => {
            blocks.classList.add('hidden');
        });
        document.querySelectorAll('.js-tabs-doc').forEach((blocks) => {
            blocks.classList.add('hidden');
        });
    }

    static bindTabClick(tabs) {
        tabs.querySelectorAll('.js-tab').forEach((tab) => {
            tab.addEventListener('click', () => {
                Tabs.hideAllBlocks(tabs);
                Tabs.showContentTab(tab);
                sessionStorage.setItem('currentTab', tab.dataset.tab);
            });
        });
    }

    static showContentTab(tab) {
        const blocks = document.querySelector(`#block-${tab.dataset.tab}`);
        const doc = document.querySelector(`#doc-${tab.dataset.tab}`);
        tab.classList.add('active');
        if (blocks) {
            blocks.classList.remove('hidden');
        }
        if (doc) {
            doc.classList.remove('hidden');
        }
    }
}

export default Tabs;
